module.exports = __webpack_public_path__ + "static/a-vida-comeca-dentro-8306f69602d12426f03676cf203041b8.jpg";